(function() { window.GUID_3af88b6c_fa1d_48fe_906e_4defc402c27c = { getGuid: function() { return "3af88b6c-fa1d-48fe-906e-4defc402c27c"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class BindedElementHelper {
            constructor($parentControl) {
                this.$parentControl = $parentControl;
                this.FindJQueryElement();
            }
            FindJQueryElement() {
                let jquerySelectors = this.$parentControl.data('bindedelementjqueryselectors');
                if (jquerySelectors != null) {
                    if (jquerySelectors.lastIndexOf(',') == jquerySelectors.length - 1) {
                        jquerySelectors = jquerySelectors.substring(0, jquerySelectors.length - 1);
                    }
                    this.bindedElements = CS.DOM.$body.find(jquerySelectors);
                }
            }
            PrepareData(data) {
                if (this.bindedElements != null) {
                    if (data == null) {
                        data = {};
                    }
                    this.bindedElements.each(function () {
                        let $this = $(this);
                        data[$this.attr('name')] = $this.val();
                    });
                }
            }
        }
        Controls.BindedElementHelper = BindedElementHelper;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=binded-elements-helper.pre.js.map
